module.exports = __webpack_public_path__ + "static/media/ic_copy_link.62a9afc5.svg";